import { render, staticRenderFns } from "./CustomerPieWidget.vue?vue&type=template&id=2acd811d&"
import script from "./CustomerPieWidget.vue?vue&type=script&lang=js&"
export * from "./CustomerPieWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports